import React from 'react'
import { NavLink as NL } from 'react-router-dom'
import { getBuildVersion, getBuildDateTime } from 'configs'
// import { Transition, Spring } from 'react-spring'
// import { TimingAnimation, Easing } from 'react-spring/dist/addons'

import { ROUTES } from '../../constants'
import Loading from '../../components/Loading'
import DashboardIcon from 'static/images/icons/poll.svg'
import PatientsIcon from 'static/images/icons/account-search-outline.svg'
import ReviewIcon from 'static/images/icons/inbox.svg'
import ReportsIcon from 'static/images/icons/clipboard-pulse-outline.svg'
import SettingsIcon from 'static/images/icons/settings.svg'
import SignOutIcon from 'static/images/icons/logout.svg'
import ReferralsIcon from 'static/images/icons/send.svg'
import KPLogo from 'static/images/kardia_pro_logo.svg'
import FeedbacksIcon from 'static/images/icons/feedbacks.svg'
import Teleconnect from 'static/images/icons/teleconnect.svg'
import SupportIcon from 'static/images/support.svg'
import ConsultationsIcon from 'static/images/icons/ConsultationIcon.svg'
import CalendarIcon from 'static/images/icons/VectorIcon.svg'
import MenuIcon from 'static/images/menu.svg'
import KPCollapse from 'static/images/back.svg'
import KardiaRx from 'static/images/kardia-rx.svg'
import styles from './NavigationSidebar.css'
import history from '../../containers/History'

const TeamProfile = props => {
  const {
    me,
    sidebarIsCollapsed,
    handleToggleNavigationSidebar,
  } = props
  const {
    isFetching,
    data,
  } = me

  let teamName = ''
  let initials = ''
  let fName = ''
  let lName = ''
  let avatar

  if (!data) {
    teamName = ''
  } else {
    const {
      name,
      logoURL,
    } = data.teams[0]
    const {
      firstName,
      lastName,
    } = data.profile
    teamName = name
    fName = firstName
    lName = lastName
    initials = firstName.charAt(0) + lastName.charAt(0)
    const avatarClassName = sidebarIsCollapsed ? 'avatarCollapsed' : 'avatar'
    const initialsClassName = sidebarIsCollapsed ? 'initialsCollapsed' : 'initials'

    if (logoURL) {
      avatar = <img className={styles[avatarClassName]} src={logoURL} />
    } else {
      avatar = <div className={styles[initialsClassName]}><span><div>{initials}</div></span></div>
    }
  }

  const profileClassName = sidebarIsCollapsed ? 'profileCollapsed' : 'profile'
  const mainLogoClassName = sidebarIsCollapsed ? 'mainLogoCollapsed' : 'mainLogo'

  // return (
  //   <div>
  //     <div className={styles.mainLogo}>
  //       <KPLogo />
  //     </div>
  //     <div className={styles.profile}>
  //       <Transition
  //         from={data ? { opacity: 1 } : { opacity: 0 }}
  //         enter={{ opacity: 1 }}
  //         leave={{ opacity: 0 }}
  //         impl={TimingAnimation}
  //         config={{ duration: 800, easing: Easing.easeInOut }}
  //       >
  //         {data
  //           /* eslint-disable-next-line */
  //           ? s => {
  //             return (
  //               <div
  //                 style={s}
  //               >
  //                 <div className={styles.initials}><span>{initials}</span></div>
  //                 <h2 className={styles.userName}>{fName} {lName}</h2>
  //                 <h2 className={styles.teamName}>
  //                   {teamName}
  //                 </h2>
  //               </div>
  //             )
  //           }
  //           /* eslint-disable-next-line */
  //           : s => {
  //             return (
  //               <div
  //                 className={styles.loader}
  //                 style={s}
  //               >
  //                 <LoadingIcon />
  //               </div>
  //             )
  //           }
  //         }
  //       </Transition>
  //     </div>
  //   </div>
  // )
  return (
    <React.Fragment>
      <div className={styles[mainLogoClassName]}>
        {
          sidebarIsCollapsed ?
            <span onClick={() => { handleToggleNavigationSidebar() }}><MenuIcon /></span>
            :
            <React.Fragment>
              <KPLogo /> <span onClick={() => { handleToggleNavigationSidebar() }}><KPCollapse /></span>
            </React.Fragment>
        }
      </div>
      <div className={styles[profileClassName]}>
        {data
          ? (
            <div>
              {avatar}
              {
                !sidebarIsCollapsed &&
                <div>
                  <h2 className={styles.userName}>{fName} {lName}</h2>
                  <h2 className={styles.teamName}>
                    {teamName}<br />
                  </h2>
                </div>
              }
            </div>
          )
          : (
            <div
              className={styles.loader}
            >
              <Loading />
            </div>
          )
        }
      </div>
    </React.Fragment>
  )
}

const renderLinkContent = props => {
  const {
    Icon,
    text,
    secondaryBullet = false,
  } = props

  return (
    <div className={styles.leftGroup}>
      {Icon &&
        <div className={styles.navIcon}>
          <Icon />
        </div>
      }
      {secondaryBullet &&
        <div className={styles.bullet} />
      }
      <span className={styles.navText}>{text}</span>
    </div>
  )
}

const NavLink = props => {
  const {
    className,
    activeClassName,
    to,
    href,
    onClick,
    target = '',
  } = props

  if (href) {
    return (
      <a href={href} className={styles.navExtLink} target={target}>
        {renderLinkContent(props)}
      </a>
    )
  }
  return (
    <NL
      className={className}
      activeClassName={activeClassName}
      onClick={() => {
        if (typeof onClick === 'function') {
          onClick()
        }
      }}
      to={to}
    >
      {renderLinkContent(props)}
    </NL>
  )
}

const Navigation = props => {
  const {
    me,
    handleLogout,
    ekgReviewHandleOnNavClick,
    qtEkgReviewHandleOnNavClick,
    KardiaRxHandleOnNavClick,
    patientDirectoryHandleOnNavClick,
    appointmentsHandleOnNavClick,
    overviewHandleOnNavClick,
    reportsHandleOnNavClick,
    settingsHandleOnNavClick,
    sidebarIsCollapsed,
  } = props

  const checkFeature = name => {
    const feature = features.find(feat => feat.feature === name)
    return feature ? feature.enabled : false
  }

  const isAdmin = me.data ? me.data.profile.permissions.isAdmin : false
  // localStorage.setItem('scripload', false);
  const isPhysician = me.data ? me.data.profile.permissions.isPhysician : false
  const features = me.data ? me.data.teams[0].features : null
  const rpmEnabled = features && checkFeature('rpm')
  const referralsEnabled = features && checkFeature('referral')
  const serviceProviderEnabled = features && checkFeature('qt-service-provider')
  const idtfEnabled = features && checkFeature('idtf')
  const idtfServiceProviderEnabled = features && checkFeature('idtf-service-provider')
  const teleconnectEnabled = features && checkFeature('teleconnect')
  const isProd = process.env.REACT_APP_API_ENV === 'production'
  const buildInfoStyles = `${styles.buildInfo} ${isProd ? styles.production : ''}`

  const getClassNameQt = () => (window.location.pathname.includes('ekg-review/recordings')
    ? 'sidebarItemActiveOverride' : 'sidebarItem')

  return (
    <React.Fragment>
      <ul className={styles.navList}>
        {!idtfServiceProviderEnabled && rpmEnabled && (
          <React.Fragment>
            <li data-action="page-navigation" data-label="Dashboard">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.DASHBOARD}
                onClick={overviewHandleOnNavClick}
                Icon={DashboardIcon}
                text="Dashboard"
              />
            </li>
            <li data-action="page-navigation" data-label="Patients">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.PATIENTS}
                onClick={patientDirectoryHandleOnNavClick}
                Icon={PatientsIcon}
                text="Patients"
              />
            </li>
          </React.Fragment>
        )}
        {!idtfServiceProviderEnabled && teleconnectEnabled && (
          <React.Fragment>
            {isAdmin &&
            <li data-action="page-navigation" data-label="Admin Dashboard">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.TELEKARDIA_ADMIN_DASHBOARD}
                onClick={appointmentsHandleOnNavClick}
                Icon={DashboardIcon}
                text="Dashboard"
              />
            </li>}
            {isPhysician &&
            <li data-action="page-navigation" data-label="Telekardia">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.TELEKARDIA_DASHBOARD}
                onClick={appointmentsHandleOnNavClick}
                Icon={Teleconnect}
                text="TeleConnect"
              />
            </li>
            }
            {isAdmin &&
            <li data-action="page-navigation" data-label="Feedbacks">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.TELEKARDIA_ADMIN_FEEDBACKS}
                onClick={appointmentsHandleOnNavClick}
                Icon={FeedbacksIcon}
                text="Feedbacks"
              />
            </li>}
            {isAdmin &&
            <li data-action="page-navigation" data-label="Calendar">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.TELEKARDIA_ADMIN_CALENDAR}
                onClick={appointmentsHandleOnNavClick}
                Icon={CalendarIcon}
                text="Scheduler"
              />
            </li>}
            {isAdmin &&
            <li data-action="page-navigation" data-label="Consultations">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.TELEKARDIA_ADMIN_CONSULTATIONS}
                onClick={appointmentsHandleOnNavClick}
                Icon={ConsultationsIcon}
                text="Consultations"
              />
            </li>}
          </React.Fragment>
        )}
        {!idtfServiceProviderEnabled && rpmEnabled && (
          <React.Fragment>
            <li data-action="page-navigation" data-label="ECG Inbox">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.EKG_REVIEW}
                onClick={() => ekgReviewHandleOnNavClick(true, false)}
                Icon={ReviewIcon}
                text="ECG Inbox"
              />
            </li>
            <li data-action="page-navigation" data-label="Reports">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.REPORTS}
                onClick={() => reportsHandleOnNavClick(true, false)}
                Icon={ReportsIcon}
                text="Reports"
              />
            </li>
          </React.Fragment>
        )}
        {!idtfServiceProviderEnabled && serviceProviderEnabled && (
          <li data-action="page-navigation" data-label="ECG Review">
            <NavLink
              className={styles[getClassNameQt()]}
              activeClassName={styles.sidebarItemActive}
              to={ROUTES.QT_EKG_REVIEW}
              onClick={() => qtEkgReviewHandleOnNavClick(true, false)}
              Icon={ReviewIcon}
              text="ECG Review"
            />
          </li>
        )}
        {!idtfServiceProviderEnabled && referralsEnabled && (
          <li data-action="page-navigation" data-label="Referrals">
            <NavLink
              className={styles.sidebarItem}
              activeClassName={styles.sidebarItemActive}
              href="/recommend"
              Icon={ReferralsIcon}
              text="Recommend"
            />
          </li>
        )}
        {!idtfServiceProviderEnabled &&
          <li data-action="page-navigation" data-label="Support">
            <NavLink
              className={styles.sidebarItem}
              activeClassName={styles.sidebarItemActive}
              href="https://kardiapro.zendesk.com/"
              target="_blank"
              Icon={SupportIcon}
              text="Support"
            />
          </li>
        }
        {!idtfServiceProviderEnabled && idtfEnabled && (
          <li data-action="page-navigation" data-label="KardiaRx">
            <NavLink
              className={styles.sidebarItem}
              activeClassName={styles.sidebarItemActive}
              to={ROUTES.IDTF_KARDIA_RX}
              onClick={() => history.push(ROUTES.IDTF_KARDIA_RX)}
              Icon={KardiaRx}
              text="KardiaRx"
            />
          </li>
        )}
        {idtfServiceProviderEnabled && (
          <React.Fragment>
            <li data-action="page-navigation" data-label="CCTPatientsList">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.CCT_PATIENTS_LIST}
                onClick={() => history.push(ROUTES.CCT_PATIENTS_LIST)}
                Icon={KardiaRx}
                text="Patients"
              />
            </li>
            <li data-action="page-navigation" data-label="CCTWorkList">
              <NavLink
                className={styles.sidebarItem}
                activeClassName={styles.sidebarItemActive}
                to={ROUTES.CCT_WORK_LIST}
                onClick={() => history.push(ROUTES.CCT_WORK_LIST)}
                Icon={KardiaRx}
                text="Worklist"
              />
            </li>
          </React.Fragment>
        )}
      </ul>
      {!sidebarIsCollapsed && (
        <div className={buildInfoStyles}>
          Build Info: <br />
          V: {getBuildVersion()}<br />
          D: {getBuildDateTime()}
        </div>
      )}
      <div className={styles.sidebarFooter}>
        <div className={styles.sidebarFooterItem} data-action="page-navigation" data-label="Settings">
          <NavLink
            className={styles.settings}
            activeClassName={styles.sidebarItemActive}
            to={ROUTES.SETTINGS}
            onClick={() => settingsHandleOnNavClick(true, false)}
            Icon={SettingsIcon}
            text="Settings"
          />
        </div>
        <button
          onClick={handleLogout}
          className={styles.logout}
          data-action="signOut"
        >
          <div className={styles.navIcon}>
            <SignOutIcon />
          </div>
          <span className={styles.navText}>Sign Out</span>
        </button>
      </div>
    </React.Fragment>
  )
}

class NavigationSidebar extends React.PureComponent {
  UNSAFE_componentWillMount() {
    this.props.getNavigationSidebarData()
  }

  render() {
    const {
      sidebarIsCollapsed,
      me,
      handleToggleNavigationSidebar,
    } = this.props

    const sidebarClassName = sidebarIsCollapsed ? 'sidebarCollapsed' : 'sidebar'

    return (
      <React.Fragment>
        <aside data-page="navigation-sidebar" className={styles[sidebarClassName]}>
          <TeamProfile me={me} sidebarIsCollapsed={sidebarIsCollapsed} handleToggleNavigationSidebar={handleToggleNavigationSidebar} />
          <Navigation
            me={me}
            {...this.props}
          />
        </aside>
      </React.Fragment>
    )
  }
}
export default NavigationSidebar



// WEBPACK FOOTER //
// ./src/legacy/containers/NavigationSidebar/NavigationSidebar.jsx